import { inject, Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs";
import { getCurrentSoftwareProductVersion } from "src/app/support/product";
import { SENTRY_CONFIG_TOKEN } from "src/app/tokens/sentry-config.token";

@Injectable()
export class SentryContextInterceptor implements HttpInterceptor {
  readonly #version = getCurrentSoftwareProductVersion();

  readonly #sentryConfig = inject(SENTRY_CONFIG_TOKEN);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(
      req.clone({
        headers: req.headers
          .set(this.#sentryConfig.requestHeaderLocation, window.location.href)
          .set(this.#sentryConfig.requestHeaderVersion, this.#version)
      })
    );
  }
}
